import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '../../services/language.service';
import { UtilityService } from "../../services/utility.service";
/**
 * Documentation Component
 */
let DocumentationComponent = class DocumentationComponent {
    constructor(httpClient, route, sanitizer, convertor, themeService, router, languageService) {
        this.httpClient = httpClient;
        this.route = route;
        this.sanitizer = sanitizer;
        this.convertor = convertor;
        this.themeService = themeService;
        this.router = router;
        this.languageService = languageService;
        this.selectedFiles = [];
        this.filesToUpload = [];
        this.fileSize = 2;
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.linkColor = '';
        this.secondaryColor = '';
        this.errorMessage = "";
        this.isUploaded = false;
        this.lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
        this.uploadClicked = false;
        if (!localStorage.getItem('user')) {
            this.router.navigateByUrl('');
        }
        this.route.params.subscribe((params) => {
            this.orderId = params['orderId'];
            this.getOrderData(this.orderId);
        });
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
        });
    }
    ngOnInit() {
        this.languageService.language.subscribe((language) => {
            this.lang = language;
        });
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.uploadClicked = true;
            const files = this.selectedFiles;
            let documentationFiles = [];
            const readUploadedFileAsDataURL = (file) => {
                const temporaryFileReader = new FileReader();
                return new Promise((resolve) => {
                    temporaryFileReader.onload = () => {
                        resolve(temporaryFileReader.result);
                        const tempFile = {
                            name: file.name,
                            content: temporaryFileReader.result
                        };
                        documentationFiles.push(tempFile);
                    };
                    temporaryFileReader.readAsDataURL(file);
                });
            };
            for (let i = 0; i < files.length; i++) {
                yield readUploadedFileAsDataURL(files[i]);
            }
            this.httpClient.post('market/order/documentation', { order_id: this.orderId, documentation_files: documentationFiles }).subscribe((success) => {
                this.isUploaded = true;
            });
        });
    }
    fileChange(event) {
        this.filesToUpload = this.toArray(event.target.files);
        if (this.selectedFiles.length == 0) {
            this.selectedFiles = this.filesToUpload;
        }
        else {
            for (let i = 0; i < this.filesToUpload.length; i++) {
                for (let j = 0; j < this.selectedFiles.length; j++) {
                    if (this.filesToUpload[i].name === this.selectedFiles[j].name) {
                        break;
                    }
                    if (j === this.selectedFiles.length - 1) {
                        this.selectedFiles = this.selectedFiles.concat(this.filesToUpload[i]);
                    }
                }
            }
        }
        document.getElementById('my-file').value = '';
        this.validateFiles();
    }
    removeFile(index) {
        this.selectedFiles.splice(index, 1);
        this.validateFiles();
    }
    validateFiles() {
        for (let i = 0; i < this.selectedFiles.length; i++) {
            let fileExtension = this.selectedFiles[i].name.split('.').pop();
            let allowed = this.checkFileExtension(fileExtension);
            if (this.selectedFiles[i].size > 1024 * 1024 * this.fileSize || !allowed) {
                this.fileError = true;
                return;
            }
        }
        this.fileError = false;
    }
    toArray(fileList) {
        return Array.prototype.slice.call(fileList);
    }
    roundNumber(num, places) {
        return Math.round(num * Math.pow(10, places)) / Math.pow(10, places);
    }
    goToTransactions() {
        this.router.navigateByUrl('/transactions');
    }
    getOrderData(oid) {
        if (oid) {
            this.httpClient.get('market/user/orders/' + oid).subscribe((data) => {
                if (data['status'] !== 'Čekanje na dokumentaciju') {
                    this.router.navigateByUrl('');
                }
                this.orderData = data;
                this.provision = this.orderData.fee_percentage_amont;
                let userData = JSON.parse(localStorage.getItem('user'));
                this.isCompanyUser = userData.is_company_user;
            }, (error) => {
                this.router.navigateByUrl('');
            });
        }
    }
    checkFileExtension(fileExtension) {
        let allowedExtensions = ['jpg', 'png', 'jpeg', 'pdf', 'gif', 'JPG', 'JPEG', 'PNG', 'PDF', 'GIF'];
        let allowed = allowedExtensions.includes(fileExtension);
        return allowed;
    }
};
DocumentationComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: DomSanitizer },
    { type: UtilityService },
    { type: WebsiteThemeService },
    { type: Router },
    { type: LanguageService }
];
DocumentationComponent = __decorate([
    Component({
        selector: 'ecd-documentation',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./documentation.component.html")).default
    })
], DocumentationComponent);
export { DocumentationComponent };
